



import readFilesIntoMemory from './readFilesIntoMemory';
import { isCLI, getSessionInfo } from './versionConfig';

export default function resolveImageUploadUrls(args){

  let urls;

  let { filenames, imageIds, imageSetIds } = args;

  if( args.readIntoMemory && args.urls ){
    throw Error(CLI_TEST_READ_ARG_CONFLICT);
  }

  if( isCLI() && !args.readIntoMemory && !args.urls ){
    console.warn(CLI_URL_WARNING);
  }
  if( args.urls ){
    if( args.urls.length !== imageIds.length ){
      throw Error(INSUFFICIENT_URLS);
    }else{
      urls = args.urls;
    }
  }else if( args.readIntoMemory ){


    urls = readFilesIntoMemory({filenames});



  }else{
    throw Error(MISSING_URLS_FOR_IMAGE_UPLOADS);
  }

  return urls;
}


const CLI_TEST_READ_ARG_CONFLICT = ("If you're trying to read something into memory, you shouldn't be passing urls. Pass either readIntoMemory OR urls, but not both.")

const INSUFFICIENT_URLS = "If you pass a `urls` args, there should be as many `urls` as there are `imageIds`.";


const CLI_URL_WARNING = ("On CLI, if you don't pass in `urls`, then the image won't show up when you load the state into GUI.")

const MISSING_URLS_FOR_IMAGE_UPLOADS = ("Image uploads need resource URLs. None were provided and you aren't reading any files for which a URL can be created.")
